export default __webpack_public_path__ + "static/media/Quiver of Raked Flesh.1e7e2085.jpg";